module.exports = __webpack_public_path__ + "static/media/acknowledgement_bg.51541933.png";